import { useState, useRef } from 'react';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './participants.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../../../../Dashboard.trans.json';
import ParticipantCard from '@/components/ParticipantCard';
import useOnClickOutside from '@/components/shared/Hooks';
import { getContactCardData, getAgentCardData } from '../../../utils';
import CustomTooltip from '@/components/propertyConfigurator/attributesSection/personalizedAttributes/customTootlip/CustomTooltip';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

const CONTACT_TYPE = 'contact';
const AGENT_TYPE = 'agent';

function EventParticipantTag({
  type = CONTACT_TYPE,
  participants = [],
  mainAgentTag = false,
  contactDataParsed = false,
  agentDataParsed = false,
  trackCallback = null,
}) {
  if (participants.length === 0) return null;

  const [showCard, setShowCard] = useState(false);
  const cardRef = useRef(null);
  useOnClickOutside(cardRef, showCard, setShowCard);

  const participantsAccount = participants.length;
  const participant = participants[0];

  const mapParticipantData = () => {
    if (type === CONTACT_TYPE) {
      if (contactDataParsed) return participant;
      return getContactCardData(participant);
    }

    if (type === AGENT_TYPE) {
      if (agentDataParsed) return participant;
      return getAgentCardData(participant);
    }

    return baseData;
  };

  const participantData = mapParticipantData();

  const remainingParticipants =
    participantsAccount > 1 ? participants.slice(1).map((p) => p.name) : [];

  const nameLabel = (
    <>
      {type === AGENT_TYPE && !mainAgentTag && (
        <Text minWidth="fit-content">{Trans(translations, 'Agent')}</Text>
      )}
      <Text
        onClick={(e) => {
          e.stopPropagation();
          setShowCard(!showCard);

          if (trackCallback) {
            trackCallback(
              type === 'contact'
                ? TRACK_ELEMENT.CONTACT_NAME
                : TRACK_ELEMENT.AGENT_NAME
            );
          }
        }}
        className={`${styles.participantName} ${
          mainAgentTag ? styles.mainAgentTag : ''
        }`}
      >
        {participant?.name}
      </Text>
      <CustomTooltip
        isTextList
        content={{ text: remainingParticipants }}
        bottom
        tooltip={{ 'min-width': 'max-content !important' }}
      >
        {participantsAccount > 1 && (
          <Text style={{ cursor: 'pointer' }}> +{participantsAccount - 1}</Text>
        )}
      </CustomTooltip>
    </>
  );

  return (
    <Box
      ref={cardRef}
      className={`${styles.participantTagContainer} ${styles.contact}`}
    >
      {showCard && <ParticipantCard data={participantData} type={type} />}

      <Box className={`${styles.participantTag} ${styles[type]}`}>
        {nameLabel}
      </Box>
    </Box>
  );
}

export default EventParticipantTag;
